export const WELCOME_MESSAGE = [
  'Pages are what make up the journeys  users take through your product.',
  'Get started by adding a new Page, or importing Pages you’ve made in another environment.'
];
